// src/components/analytics/components/PortfolioOverview.js
import React, { useState } from 'react';
import {
    Card,
    CardContent,
    Box,
    Typography,
    TextField,
    MenuItem,
    useTheme
} from '@mui/material';
import {
    AreaChart,
    Area,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip as RechartsTooltip,
    ResponsiveContainer,
    Legend
} from 'recharts';
import CustomTooltip from './CustomTooltip';

const periodOptions = [
    { value: 'yearly', label: 'Yearly' },
    { value: 'quarterly', label: 'Quarterly' },
    { value: 'monthly', label: 'Monthly' }
];

const PortfolioOverview = ({ data }) => {
    const theme = useTheme();
    const [periodType, setPeriodType] = useState('yearly');

    return (
        <Card
            elevation={0}
            sx={{
                height: '100%',
                borderRadius: 2,
                border: `1px solid ${theme.palette.divider}`
            }}
        >
            <CardContent>
                <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
                    <Typography variant="h6">
                        Portfolio Overview
                    </Typography>
                   {/* <TextField
                        select
                        size="small"
                        value={periodType}
                        onChange={(e) => setPeriodType(e.target.value)}
                        sx={{ width: 130 }}
                    >
                        {periodOptions.map(option => (
                            <MenuItem key={option.value} value={option.value}>
                                {option.label}
                            </MenuItem>
                        ))}
                    </TextField>*/}
                </Box>
                <Box sx={{ height: 500 }}>
                    <ResponsiveContainer width="100%" height="100%">
                        <AreaChart
                            data={data}
                            margin={{ top: 10, right: 30, left: 10, bottom: 10 }}
                        >
                            <defs>
                                <linearGradient id="colorIncome" x1="0" y1="0" x2="0" y2="1">
                                    <stop offset="5%" stopColor={theme.palette.success.main} stopOpacity={0.8} />
                                    <stop offset="95%" stopColor={theme.palette.success.main} stopOpacity={0.1} />
                                </linearGradient>
                                <linearGradient id="colorExpenses" x1="0" y1="0" x2="0" y2="1">
                                    <stop offset="5%" stopColor={theme.palette.error.main} stopOpacity={0.8} />
                                    <stop offset="95%" stopColor={theme.palette.error.main} stopOpacity={0.1} />
                                </linearGradient>
                                <linearGradient id="colorProfit" x1="0" y1="0" x2="0" y2="1">
                                    <stop offset="5%" stopColor={theme.palette.primary.main} stopOpacity={0.8} />
                                    <stop offset="95%" stopColor={theme.palette.primary.main} stopOpacity={0.1} />
                                </linearGradient>
                            </defs>
                            <XAxis
                                dataKey="name"
                                axisLine={false}
                                tickLine={false}
                                tick={{ fontSize: 12 }}
                            />
                            <YAxis
                                axisLine={false}
                                tickLine={false}
                                tick={{ fontSize: 12 }}
                                tickFormatter={(value) => `${value / 1000}k`}
                            />
                            <CartesianGrid strokeDasharray="3 3" vertical={false} />
                            <RechartsTooltip content={<CustomTooltip />} />
                            <Area
                                type="monotone"
                                dataKey="transactions"
                                name="Income"
                                stroke={theme.palette.success.main}
                                fillOpacity={1}
                                fill="url(#colorIncome)"
                                strokeWidth={2}
                            />
                            <Area
                                type="monotone"
                                dataKey="expenses"
                                name="Expenses"
                                stroke={theme.palette.error.main}
                                fillOpacity={1}
                                fill="url(#colorExpenses)"
                                strokeWidth={2}
                            />
                            <Area
                                type="monotone"
                                dataKey="profit"
                                name="Profit"
                                stroke={theme.palette.primary.main}
                                fillOpacity={1}
                                fill="url(#colorProfit)"
                                strokeWidth={2}
                            />
                            <Legend
                                verticalAlign="bottom"
                                height={36}
                                iconType="circle"
                                iconSize={10}
                            />
                        </AreaChart>
                    </ResponsiveContainer>
                </Box>
            </CardContent>
        </Card>
    );
};

export default PortfolioOverview;